import { User } from '@modules/auth/hooks/types'

import { PendoSearchEventType } from '../types'
import { getEventDefaultInfo } from '../utils'

const descriptionMap: Record<PendoSearchEventType, string> = {
  [PendoSearchEventType.SearchIconTrigger]: 'Type keyword(s) and click on magnifying glass button',
  [PendoSearchEventType.PredictiveSearch]: 'Type keyword(s) and select a predictive search option',
  [PendoSearchEventType.SearchEnterTrigger]: 'Type keyword(s) and press enter',
  [PendoSearchEventType.ClearSearchIcon]: 'Click on the x in the keyword search box',
}

export const preparePendoSearchEvent = ({ eventType, user }: { eventType: PendoSearchEventType; user?: User | null }) => {
  return {
    ...getEventDefaultInfo(user),
    eventType: descriptionMap[eventType] || `Unknown trigger: ${eventType}`,
  }
}
